exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html, body, .fullsize {\n    width: 100%;\n    height: 100%;\n}\n\nhtml, body {\n    overflow: hidden;\n}", ""]);

